import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./ReportAbuseUIHelpers";

const ReportAbuseUIContext = createContext();

export function useReportAbuseUIContext() {
  return useContext(ReportAbuseUIContext);
}

export const ReportAbuseUIConsumer = ReportAbuseUIContext.Consumer;

export function ReportAbuseUIProvider({
  reportAbuseUIEvents,
  children,
  queryParams,
  setQueryParamsBase,
  ids,
  setIds,
}) {
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openReceiptDialog: reportAbuseUIEvents.openReceiptDialog,
    openDeleteDialog: reportAbuseUIEvents.openDeleteDialog,
  };

  return (
    <ReportAbuseUIContext.Provider value={value}>
      {children}
    </ReportAbuseUIContext.Provider>
  );
}
